/* STRYD wishlist (replaces the Vitals wishlist), 2026-10-18.
   Saved pieces live in this browser (localStorage "stryd_wishlist"), so no login is needed.
   Adds: a heart on every product card, a "Save to wishlist" button on the product page, a heart with a count in the
   header, and a side panel listing saved pieces. Each save sends "Added to Wishlist" to Klaviyo when Klaviyo is loaded.
   Config + current product come from snippets/stryd-wishlist.liquid (window.STRYD_WISHLIST). */
(function () {
  'use strict';
  var CFG = window.STRYD_WISHLIST || {};
  var KEY = 'stryd_wishlist';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M12 20.5s-7.5-4.6-9.3-9.4C1.4 7.6 3.6 4.5 6.9 4.5c2 0 3.6 1.1 5.1 3 1.5-1.9 3.1-3 5.1-3 3.3 0 5.5 3.1 4.2 6.6-1.8 4.8-9.3 9.4-9.3 9.4z"/></svg>';

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function write(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} render(); }
  function has(handle) { return read().some(function (i) { return i.handle === handle; }); }
  function handleFromUrl(url) { var m = /\/products\/([^/?#]+)/.exec(url || ''); return m ? decodeURIComponent(m[1]) : null; }

  function track(item) {
    if (CFG.klaviyo === false) return;
    var props = { ProductName: item.title, ProductHandle: item.handle, URL: location.origin + item.url, ImageURL: item.image, Price: item.price };
    try {
      if (window.klaviyo && typeof window.klaviyo.push === 'function') window.klaviyo.push(['track', 'Added to Wishlist', props]);
      else if (window._learnq) window._learnq.push(['track', 'Added to Wishlist', props]);
    } catch (e) {}
  }

  function toggle(item) {
    var list = read();
    var idx = list.findIndex(function (i) { return i.handle === item.handle; });
    if (idx > -1) { list.splice(idx, 1); write(list); return false; }
    list.unshift(item); write(list); track(item); return true;
  }

  /* ---------- product cards ---------- */
  function cardItem(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var handle = handleFromUrl(link.getAttribute('href'));
    if (!handle) return null;
    var titleEl = card.querySelector('.card__heading a, .card__heading, .pfas-card__name, [class*="__title"], h3, h2');
    var img = card.querySelector('img');
    var priceEl = card.querySelector('.price-item--sale:not(.hidden), .price__sale .price-item--sale, .price-item--regular, .pfas-card__price, [class*="price"]');
    return {
      handle: handle,
      url: '/products/' + handle,
      title: (titleEl ? titleEl.textContent : link.textContent || handle).replace(/\s+/g, ' ').trim(),
      image: img ? (img.currentSrc || img.src || '').replace(/^\/\//, 'https://') : '',
      price: priceEl ? priceEl.textContent.replace(/\s+/g, ' ').trim() : ''
    };
  }

  function makeButton(item, cls) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = cls;
    b.setAttribute('data-wl-handle', item.handle);
    b.innerHTML = HEART + (cls.indexOf('--pdp') > -1 ? '<span class="stryd-wl__label"></span>' : '');
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var saved = toggle(item);
      if (saved) bump();
    });
    return b;
  }

  function decorateCards(root) {
    (root || document).querySelectorAll('.product-card-wrapper, .pfas-card').forEach(function (card) {
      if (card.hasAttribute('data-wl')) return;
      var item = cardItem(card);
      if (!item) return;
      card.setAttribute('data-wl', '');
      /* The heart sits at the right end of the product name, under the photo: the photos carry text in every corner
         (PFAS tag, model size note, deal bands). On Dawn cards it hangs off .card so it stays above the card's
         full-size link (the hover lift traps anything inside .card__inner beneath that link). */
      var holder = card.querySelector('.card') || card;
      var title = card.querySelector('.card > .card__content .card__heading') || card.querySelector('.pfas-card__name, [class*="__title"], h3, h2');
      if (!title) return;
      holder.classList.add('stryd-wl-host');
      title.classList.add('stryd-wl-title');
      var b = makeButton(item, 'stryd-wl__heart stryd-wl__heart--float');
      holder.appendChild(b);
      pin(b, holder, title);
    });
    sync();
  }

  /* place a floating heart level with the first line of ref (the product name), at its right edge; re-place on resize */
  var pinned = [];
  function placeOne(o) {
    var h = o.holder.getBoundingClientRect(), r = o.ref.getBoundingClientRect();
    o.btn.style.top = Math.max(0, r.top - h.top - (o.btn.offsetHeight - 20) / 2) + 'px';
    o.btn.style.right = Math.max(0, h.right - r.right - 8) + 'px';
  }
  function pin(btn, holder, ref) {
    var o = { btn: btn, holder: holder, ref: ref };
    pinned.push(o); placeOne(o);
    if (window.ResizeObserver) new ResizeObserver(function () { placeOne(o); }).observe(ref);
  }
  window.addEventListener('load', function () { pinned.forEach(placeOne); });
  window.addEventListener('resize', function () { pinned.forEach(placeOne); });

  /* ---------- product page ---------- */
  function decoratePdp() {
    var p = CFG.product;
    if (!p) return;
    var buttons = document.querySelector('.product-form__buttons');
    if (buttons && !buttons.parentNode.querySelector('.stryd-wl__heart--pdp')) {
      buttons.parentNode.insertBefore(makeButton(p, 'stryd-wl__heart stryd-wl__heart--pdp'), buttons.nextSibling);
    }
    /* heart beside the product title too */
    var t = document.querySelector('.product__title');
    if (t && !t.querySelector('.stryd-wl__heart--title')) {
      t.classList.add('stryd-wl-host', 'stryd-wl-title');
      t.appendChild(makeButton(p, 'stryd-wl__heart stryd-wl__heart--title'));
    }
    sync();
  }

  /* ---------- header icon + panel ---------- */
  var panel, list, countEl;
  function buildHeader() {
    var icons = document.querySelector('.header__icons');
    if (!icons || icons.querySelector('.stryd-wl__open')) return;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'stryd-wl__open header__icon link focus-inset';
    b.setAttribute('aria-label', 'Wishlist');
    b.innerHTML = HEART + '<span class="stryd-wl__count" hidden></span>';
    b.addEventListener('click', open);
    var cart = icons.querySelector('#cart-icon-bubble');
    icons.insertBefore(b, cart || null);
    countEl = b.querySelector('.stryd-wl__count');

    panel = document.createElement('div');
    panel.className = 'stryd-wl__panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', 'Wishlist');
    panel.hidden = true;
    panel.innerHTML =
      '<div class="stryd-wl__scrim" data-wl-close></div>' +
      '<aside class="stryd-wl__drawer">' +
        '<header class="stryd-wl__head"><h2>Wishlist</h2><button type="button" class="stryd-wl__close" data-wl-close aria-label="Close">&times;</button></header>' +
        '<ul class="stryd-wl__list"></ul>' +
        '<p class="stryd-wl__empty">Nothing saved yet. Tap the heart on any piece to keep it here.</p>' +
      '</aside>';
    document.body.appendChild(panel);
    list = panel.querySelector('.stryd-wl__list');
    panel.addEventListener('click', function (e) {
      if (e.target.closest('[data-wl-close]')) close();
      else if (e.target.closest('.stryd-wl__item a')) close(); /* going to a saved product closes the panel */
    });
    /* any click or tap outside the panel closes it */
    document.addEventListener('pointerdown', function (e) {
      if (panel.hidden || e.target.closest('.stryd-wl__drawer, .stryd-wl__open')) return;
      close();
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden) close(); });
  }
  function open() {
    render(); panel.hidden = false; document.documentElement.classList.add('stryd-wl-open');
    var c = panel.querySelector('.stryd-wl__close'); if (c) c.focus();
    refreshPrices();
  }
  function close() { panel.hidden = true; document.documentElement.classList.remove('stryd-wl-open'); }
  function bump() {
    var b = document.querySelector('.stryd-wl__open'); if (!b) return;
    b.classList.remove('is-bumped'); void b.offsetWidth; b.classList.add('is-bumped');
  }

  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function render() {
    sync();
    if (!list) return;
    var items = read();
    panel.classList.toggle('is-empty', !items.length);
    list.innerHTML = items.map(function (i) {
      return '<li class="stryd-wl__item" data-handle="' + esc(i.handle) + '">' +
        '<a class="stryd-wl__img" href="' + esc(i.url) + '">' + (i.image ? '<img src="' + esc(i.image) + '" alt="" loading="lazy" width="96" height="120">' : '') + '</a>' +
        '<div class="stryd-wl__info"><a class="stryd-wl__title" href="' + esc(i.url) + '">' + esc(i.title) + '</a>' +
        '<span class="stryd-wl__price">' + esc(i.price) + '</span>' +
        '<div class="stryd-wl__picker" data-picker="' + esc(i.handle) + '"></div>' +
        '<div class="stryd-wl__actions"><button type="button" class="stryd-wl__add" data-add="' + esc(i.handle) + '" disabled>Loading</button>' +
        '<button type="button" class="stryd-wl__remove" data-remove="' + esc(i.handle) + '">Remove</button></div></div></li>';
    }).join('');
    items.forEach(function (i) { loadProduct(i.handle).then(function (p) { if (p) hydrate(i.handle, p); }); });
    list.querySelectorAll('[data-remove]').forEach(function (b) {
      b.addEventListener('click', function () {
        write(read().filter(function (i) { return i.handle !== b.getAttribute('data-remove'); }));
      });
    });
  }

  /* ---------- pick colour + size and add to cart, inside the panel ---------- */
  var PRODUCTS = {};
  function loadProduct(handle) {
    if (!PRODUCTS[handle]) {
      PRODUCTS[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return undefined; });
    }
    return PRODUCTS[handle];
  }
  var picks = {};  /* handle -> chosen value per option */
  function matches(v, sel) {
    for (var k = 0; k < sel.length; k++) { if (sel[k] != null && v.options[k] !== sel[k]) return false; }
    return true;
  }
  function isColour(o) { return /colou?r/i.test(o.name); }
  function hydrate(handle, p) {
    if (!list) return;
    var box = list.querySelector('[data-picker="' + CSS.escape(handle) + '"]');
    var btn = list.querySelector('[data-add="' + CSS.escape(handle) + '"]');
    if (!box || !btn) return;
    var opts = p.options || [];
    var sel = picks[handle] || opts.map(function () { return null; });
    /* one-value options (e.g. a single colour) are picked for them */
    opts.forEach(function (o, k) { if (o.values.length === 1) sel[k] = o.values[0]; });
    /* start on the first colour with stock, so usually only the size is left to choose */
    opts.forEach(function (o, k) {
      if (sel[k] == null && isColour(o)) {
        var first = p.variants.find(function (v) { return v.available; });
        if (first) sel[k] = first.options[k];
      }
    });
    picks[handle] = sel;
    var hasDefault = opts.length === 1 && opts[0].values.length === 1 && /default/i.test(opts[0].values[0]);
    box.innerHTML = hasDefault ? '' : opts.map(function (o, k) {
      if (o.values.length === 1) return '<div class="stryd-wl__opt"><span class="stryd-wl__optname">' + esc(o.name) + ': ' + esc(o.values[0]) + '</span></div>';
      return '<div class="stryd-wl__opt"><span class="stryd-wl__optname">' + esc(o.name) + (sel[k] ? ': ' + esc(sel[k]) : '') + '</span><div class="stryd-wl__chips">' +
        o.values.map(function (val) {
          var trial = sel.slice(); trial[k] = val;
          var ok = p.variants.some(function (v) { return v.available && matches(v, trial); });
          var on = sel[k] === val;
          return '<button type="button" class="stryd-wl__chip' + (on ? ' is-on' : '') + (ok ? '' : ' is-out') + '" data-k="' + k + '" data-v="' + esc(val) + '"' +
            (ok ? '' : ' aria-disabled="true"') + ' aria-pressed="' + on + '">' + esc(val) + '</button>';
        }).join('') + '</div></div>';
    }).join('');
    box.querySelectorAll('.stryd-wl__chip').forEach(function (c) {
      c.addEventListener('click', function () {
        if (c.classList.contains('is-out')) return;
        var k = +c.getAttribute('data-k'), val = c.getAttribute('data-v');
        sel[k] = (sel[k] === val && !isColour(opts[k])) ? null : val;
        /* a colour change can leave a size with no stock in that colour: clear it */
        if (!p.variants.some(function (v) { return v.available && matches(v, sel); })) {
          opts.forEach(function (o, j) { if (j !== k && o.values.length > 1) sel[j] = null; });
        }
        hydrate(handle, p);
      });
    });
    /* photo follows the chosen colour (2026-10-18); a colour without its own photo keeps the current one */
    var ci = opts.findIndex(isColour);
    if (ci > -1 && sel[ci] != null) {
      var cv = p.variants.find(function (v) { return v.options[ci] === sel[ci] && v.featured_image && v.featured_image.src; });
      var imgBox = list.querySelector('.stryd-wl__item[data-handle="' + CSS.escape(handle) + '"] .stryd-wl__img');
      if (cv && imgBox) {
        var src = cv.featured_image.src.replace(/^\/\//, 'https://');
        src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=240';
        var im = imgBox.querySelector('img');
        if (!im) { im = document.createElement('img'); im.alt = ''; im.width = 96; im.height = 120; imgBox.appendChild(im); }
        if (im.getAttribute('src') !== src) im.setAttribute('src', src);
      }
    }
    var complete = sel.every(function (x) { return x != null; });
    var variant = complete ? p.variants.find(function (v) { return v.available && matches(v, sel); }) : null;
    var anyStock = p.variants.some(function (v) { return v.available; });
    var missing = opts.filter(function (o, k) { return sel[k] == null; }).map(function (o) { return o.name.toLowerCase(); });
    btn.disabled = !variant;
    btn.textContent = !anyStock ? 'Sold out' : variant ? 'Add to cart' : 'Select ' + (missing[0] || 'an option');
    btn.onclick = variant ? function () { addToCart(variant.id, btn, p.handle); } : null;
  }

  /* handle: the saved piece this button belongs to. Once it's in the cart it comes off the wishlist (2026-10-18). */
  function addToCart(id, btn, handle) {
    btn.disabled = true; btn.textContent = 'Adding';
    var dawn = document.querySelector('cart-drawer');
    var body = { items: [{ id: id, quantity: 1 }] };
    if (dawn && typeof dawn.getSectionsToRender === 'function') {
      body.sections = dawn.getSectionsToRender().map(function (x) { return x.id; });
      body.sections_url = location.pathname;
    }
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) { btn.disabled = false; btn.textContent = 'Try again'; return; }
        if (handle) write(read().filter(function (i) { return i.handle !== handle; }));
        close();
        /* Essential Cart opens itself on add; otherwise use the theme's cart drawer, or the cart page */
        setTimeout(function () {
          if (document.documentElement.className.indexOf('essential-cart__open') > -1) return;
          if (dawn && typeof dawn.renderContents === 'function' && res.json.sections) {
            dawn.classList.remove('is-empty'); dawn.renderContents(res.json);
          } else { location.href = '/cart'; }
        }, 900);
      })
      .catch(function () { btn.disabled = false; btn.textContent = 'Try again'; });
  }

  /* keep saved prices and images current; drop products that no longer exist */
  var refreshed = false;
  function refreshPrices() {
    if (refreshed) return; refreshed = true;
    var items = read();
    Promise.all(items.map(function (i) {
      return loadProduct(i.handle);
    })).then(function (res) {
      var changed = false;
      var next = items.filter(function (i, n) {
        var p = res[n];
        if (p === null) { changed = true; return false; }
        if (p) {
          var price = (CFG.moneyFormat || '${{amount}}').replace(/\{\{\s*amount[^}]*\}\}/, (p.price / 100).toFixed(2).replace(/\.00$/, ''));
          if (price !== i.price) { i.price = price; changed = true; }
          if (p.featured_image && !i.image) { i.image = p.featured_image.replace(/^\/\//, 'https://'); changed = true; }
        }
        return true;
      });
      if (changed) write(next);
    });
  }

  function sync() {
    var items = read();
    document.querySelectorAll('[data-wl-handle]').forEach(function (b) {
      var on = items.some(function (i) { return i.handle === b.getAttribute('data-wl-handle'); });
      b.classList.toggle('is-saved', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
      b.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save to wishlist');
      var l = b.querySelector('.stryd-wl__label'), t = on ? 'Saved to wishlist' : 'Save to wishlist';
      if (l && l.textContent !== t) l.textContent = t;
    });
    if (countEl) { var c = String(items.length); if (countEl.textContent !== c) countEl.textContent = c; countEl.hidden = !items.length; }
  }

  function init() {
    buildHeader(); decorateCards(); decoratePdp(); render();
    /* re-run for cards added later (filters, infinite scroll, recommendations); ignore our own nodes so it can't loop */
    var queued = false;
    new MutationObserver(function (muts) {
      if (queued) return;
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (!muts[i].addedNodes.length || (t.closest && t.closest('.stryd-wl__heart, .stryd-wl__open, .stryd-wl__panel'))) continue;
        if (muts[i].addedNodes.length === 1 && muts[i].addedNodes[0].classList && muts[i].addedNodes[0].classList.contains('stryd-wl__heart')) continue;
        queued = true;
        requestAnimationFrame(function () { queued = false; decorateCards(); decoratePdp(); buildHeader(); });
        break;
      }
    }).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('storage', function (e) { if (e.key === KEY) render(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
